import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lame-form base-card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, " Choix des lames ", -1)
const _hoisted_3 = { class: "col-grid-2" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-grid-2" }
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "lame-choisie" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", null, "Aucune lame choisie", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", null, "Lame choisie", -1)
const _hoisted_22 = ["innerHTML"]

import { DEFAULT_SURFACE, glouton, howManyNeedForFill, IProduct, onlyUnique } from '@/model/Product';
// import { DigInputNumber } from '@digithia/input/number';
import { computed } from '@vue/reactivity';
import { ref, PropType, onMounted } from 'vue'

enum LameType {
  cl = 'cl',
  cv = 'cv',
}

interface LameForm {
  type: LameType
  surface: number
  couleur: string
  longueur: string
  hauteur: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
  lames: { type: Array as PropType<IProduct[]>, default: () => [] },
},
  emits: ['update', 'updateAccessoire', 'updateSurface'],
  setup(__props, { emit: emits }) {

const props = __props



const DEFAULT_FORM_LAME: LameForm = {
  type: LameType.cl,
  surface: DEFAULT_SURFACE,
  hauteur: '',
  longueur: '',
  couleur: '',
}

const longueurs = computed(() => {
  return props.lames
    .filter(l => l.categorie === form.value.type || !form.value.type)
    .filter(l => l.couleur === form.value.couleur || !form.value.couleur)
    .map(l => l.longueur)
    .filter(onlyUnique)
})

const hauteurs = computed(() => {
  return props.lames
    .filter(l => l.categorie === form.value.type || !form.value.type)
    .filter(l => l.couleur === form.value.couleur || !form.value.couleur)
    .map(l => l.hauteur_utile_mm)
    .filter(onlyUnique)
})

const couleurs = computed(() => {
  return props.lames
    .filter(l => l.categorie === form.value.type)
    .map(l => l.couleur)
    .filter(onlyUnique)
    .filter(c => !c.match('COL_'))
})

const types = computed(() => {
  return [{ type: 'cl', name: 'Classiques' }, { type: 'cv', name: 'Claire-voie' }]
})

const choosenLame = computed(() => {
  return props.lames
    .find(l =>
      l.categorie === form.value.type
      && l.couleur === form.value.couleur
      && l.hauteur_utile_mm === form.value.hauteur
      && l.longueur === form.value.longueur
    )
})



const form = ref(DEFAULT_FORM_LAME)

onMounted(() => {
  setTimeout(() => {
    const input = document.querySelector('#input-surface') as any | undefined
    if (input) {
      input.errors.min = 'Doit être supérieure à 20 m²'
    }
  })
})

const update = (key: keyof LameForm, value: any) => {
  form.value[key] = value as never

  emits('update', choosenLame.value)

  if (choosenLame.value) {
    const surface = (+choosenLame.value.longueur * (+choosenLame.value.hauteur_utile_mm / 1000)) || 0

    emits('updateAccessoire', {
      quantity: Math.ceil(howManyNeedForFill(surface, form.value.surface)),
      product: choosenLame.value,
    })
  }

  if (key === 'surface') {
    emits('updateSurface', form.value.surface)
  }

  if (key === 'type') {
    // form.value.couleur = ''
  }
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("dig-input-number", {
        id: "input-surface",
        value: form.value.surface,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (update('surface', $event.target.value))),
        suffix: "m²",
        required: "",
        min: 20
      }, " Surface ", 40, _hoisted_4),
      (_unref(types).length)
        ? (_openBlock(), _createElementBlock("dig-input-select-picker", {
            key: 0,
            class: "select-type",
            required: "",
            label: "Type de lame",
            value: form.value.type,
            onSelect: _cache[1] || (_cache[1] = ($event: any) => (update('type', $event.detail)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(types), (type) => {
              return (_openBlock(), _createElementBlock("dig-input-select-picker-option", {
                key: type.type,
                value: type.type
              }, _toDisplayString(type.name), 9, _hoisted_6))
            }), 128))
          ], 40, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (_unref(couleurs).length && form.value.type === 'cl')
        ? (_openBlock(), _createElementBlock("dig-input-select-picker", {
            key: 0,
            class: "select-couleur",
            required: "",
            label: "Couleurs",
            value: form.value.couleur,
            onSelect: _cache[2] || (_cache[2] = ($event: any) => (update('couleur', $event.detail)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(couleurs), (couleur) => {
              return (_openBlock(), _createElementBlock("dig-input-select-picker-option", {
                key: couleur,
                value: couleur
              }, _toDisplayString(couleur), 9, _hoisted_8))
            }), 128))
          ], 40, _hoisted_7))
        : _createCommentVNode("", true),
      (_unref(couleurs).length && form.value.type === 'cv')
        ? (_openBlock(), _createElementBlock("dig-input-select-picker", {
            key: 1,
            class: "select-couleur",
            required: "",
            label: "Couleurs",
            value: form.value.couleur,
            onSelect: _cache[3] || (_cache[3] = ($event: any) => (update('couleur', $event.detail)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(couleurs), (couleur) => {
              return (_openBlock(), _createElementBlock("dig-input-select-picker-option", {
                key: couleur,
                value: couleur
              }, _toDisplayString(couleur), 9, _hoisted_10))
            }), 128))
          ], 40, _hoisted_9))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("dig-input-radio-wrapper", {
        required: "",
        class: "radio-longueurs",
        label: "Longueur",
        value: form.value.longueur,
        onInput: _cache[4] || (_cache[4] = ($event: any) => (update('longueur', $event.target.value)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(longueurs), (longueur) => {
          return (_openBlock(), _createElementBlock("dig-input-radio", {
            key: longueur,
            value: longueur
          }, _toDisplayString(longueur) + " m ", 9, _hoisted_13))
        }), 128))
      ], 40, _hoisted_12),
      _createElementVNode("dig-input-radio-wrapper", {
        required: "",
        class: "radio-hauteurs",
        label: "Hauteur",
        value: form.value.hauteur,
        onInput: _cache[5] || (_cache[5] = ($event: any) => (update('hauteur', $event.target.value)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hauteurs), (hauteur) => {
          return (_openBlock(), _createElementBlock("dig-input-radio", {
            key: hauteur,
            value: hauteur
          }, _toDisplayString(form.value.type === 'cv' && hauteur === '200' ? '195' : hauteur) + " mm ", 9, _hoisted_15))
        }), 128))
      ], 40, _hoisted_14)
    ]),
    _createElementVNode("div", _hoisted_16, [
      (!_unref(choosenLame))
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
        : _createCommentVNode("", true),
      (_unref(choosenLame))
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", {
              innerHTML: _unref(choosenLame)?.description_base
            }, null, 8, _hoisted_22)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})